export default __webpack_public_path__ + "static/media/odam.34066470.png";